import { render } from "./FileManager.vue?vue&type=template&id=15c56cb3&scoped=true"
import script from "./FileManager.vue?vue&type=script&lang=js"
export * from "./FileManager.vue?vue&type=script&lang=js"

import "./FileManager.vue?vue&type=style&index=0&id=15c56cb3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c56cb3"]])

export default __exports__